import React, { useState, useRef } from 'react';
import { DB, uploadImage } from '../../data/database';
import { getContact } from './websiteStyles';

const INK = '#14161C';
const INK2 = '#52545C';
const INK3 = '#8B8D94';
const INK4 = '#B0B2B8';
const LINE = '#E5E5E3';
const BLUE = '#2563EB';
const GREEN = '#22C55E';
const DARK = '#14161C';
const PAPER = '#FAFAF8';
const heading = '"Inter Tight", sans-serif';
const mono = '"JetBrains Mono", monospace';
const serif = '"Instrument Serif", serif';

const COUNTRIES = ['UAE', 'Saudi Arabia', 'Kuwait', 'Bahrain', 'Qatar', 'Oman', 'Kazakhstan', 'Russia', 'Georgia', 'Azerbaijan', 'Kenya', 'Tanzania', 'Uganda', 'Mozambique', 'DR Congo', 'Pakistan', 'India', 'Bangladesh', 'Turkey', 'Other'];

function WebsiteTradeApply() {
  const c = getContact();
  const fileRef = useRef();
  const [submitted, setSubmitted] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [docs, setDocs] = useState([]);
  const [f, setF] = useState({
    business_name: '', business_city: '', business_country: '', business_type: 'dealer',
    contact_name: '', contact_position: 'Owner', contact_email: '', contact_phone: '',
    license_type: 'Trade License', license_number: '',
    monthly_volume: 'less_than_5', interested_in: ['vehicles'], notes: '',
  });

  const set = (k, v) => setF(prev => ({ ...prev, [k]: v }));
  const toggleInterest = (val) => setF(prev => ({
    ...prev, interested_in: prev.interested_in.includes(val)
      ? prev.interested_in.filter(x => x !== val)
      : [...prev.interested_in, val],
  }));

  const handleFileUpload = async (e) => {
    const files = Array.from(e.target.files);
    if (!files.length) return;
    setUploading(true);
    for (const file of files) {
      if (file.size > 10 * 1024 * 1024) { alert(`${file.name} exceeds 10MB limit.`); continue; }
      try {
        const reader = new FileReader();
        const url = await new Promise((resolve) => {
          reader.onload = async (ev) => {
            const uploaded = await uploadImage(ev.target.result, 'trade-applications');
            resolve(uploaded || ev.target.result);
          };
          reader.readAsDataURL(file);
        });
        setDocs(prev => [...prev, { id: Date.now().toString(36) + Math.random().toString(36).slice(2, 4), name: file.name, type: 'other', url, uploaded_at: new Date().toISOString() }]);
      } catch {}
    }
    setUploading(false);
    e.target.value = '';
  };

  const handleSubmit = () => {
    if (!f.business_name.trim() || !f.business_country || !f.contact_name.trim() || !f.contact_email.trim()) {
      alert('Please fill in all required fields: Business name, Country, Contact name, Email.');
      return;
    }
    const apps = DB.get('tradeApplications') || [];
    const newApp = {
      id: 'TA-' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6),
      ...f,
      documents: docs,
      status: 'pending',
      created_at: new Date().toISOString(),
      updated_at: new Date().toISOString(),
    };
    DB.set('tradeApplications', [...apps, newApp]);
    setSubmitted(true);
    window.scrollTo(0, 0);
  };

  const inputStyle = { width: '100%', height: 48, padding: '0 16px', borderRadius: 10, border: `1px solid ${LINE}`, background: '#fff', fontFamily: heading, fontSize: 14, color: INK, outline: 'none', boxSizing: 'border-box' };
  const labelStyle = { fontSize: 13, fontWeight: 600, color: INK, marginBottom: 6, display: 'block' };

  if (submitted) {
    return (
      <div>
        <section style={{ maxWidth: 1440, margin: '0 auto', padding: '80px 24px', textAlign: 'center' }}>
          <div style={{ fontSize: 64, marginBottom: 20 }}>✅</div>
          <h1 style={{ fontFamily: heading, fontSize: 36, fontWeight: 700, color: INK, letterSpacing: '-0.03em', marginBottom: 12 }}>Application Submitted!</h1>
          <p style={{ fontSize: 16, color: INK3, maxWidth: 480, margin: '0 auto 32px', lineHeight: 1.7 }}>
            We'll review your documents and get back to you within 48 hours. You'll receive an email at <strong>{f.contact_email}</strong> once your application is processed.
          </p>
          <a href={`https://wa.me/${c.whatsapp}`} target="_blank" rel="noopener noreferrer" style={{ display: 'inline-flex', alignItems: 'center', gap: 8, padding: '14px 28px', borderRadius: 9999, background: GREEN, color: '#fff', fontSize: 14, fontWeight: 600, textDecoration: 'none', fontFamily: heading }}>
            WhatsApp Us for Faster Response
          </a>
        </section>
      </div>
    );
  }

  return (
    <div>
      {/* Hero */}
      <section style={{ background: DARK, color: PAPER, position: 'relative', overflow: 'hidden' }}>
        <div style={{ position: 'absolute', inset: 0, opacity: 0.03, pointerEvents: 'none', backgroundImage: `linear-gradient(rgba(250,250,248,0.5) 1px, transparent 1px), linear-gradient(90deg, rgba(250,250,248,0.5) 1px, transparent 1px)`, backgroundSize: '80px 80px' }} />
        <div style={{ maxWidth: 1440, margin: '0 auto', padding: '80px 24px', position: 'relative' }}>
          <div style={{ fontFamily: mono, fontSize: 10, letterSpacing: '0.14em', textTransform: 'uppercase', color: 'rgba(250,250,248,0.35)', marginBottom: 20, display: 'flex', alignItems: 'center', gap: 8 }}>
            <span style={{ width: 5, height: 5, borderRadius: '50%', background: GREEN }}></span>
            Trade Partners
          </div>
          <h1 style={{ fontFamily: heading, fontWeight: 700, letterSpacing: '-0.04em', fontSize: 'clamp(32px, 5vw, 56px)', lineHeight: 0.95, maxWidth: 600, marginBottom: 20 }}>
            Apply for a{' '}
            <span style={{ fontFamily: serif, fontStyle: 'italic', color: '#60A5FA', fontWeight: 400 }}>buyer account.</span>
          </h1>
          <p style={{ fontSize: 15, color: 'rgba(250,250,248,0.4)', maxWidth: 480, lineHeight: 1.7 }}>
            Get access to pricing, bulk ordering, and dedicated support. Businesses and individual buyers welcome.
          </p>
        </div>
      </section>

      {/* Form */}
      <section style={{ maxWidth: 720, margin: '0 auto', padding: '48px 24px 80px' }}>

        {/* Business section */}
        <div style={{ marginBottom: 32 }}>
          <div style={{ fontFamily: mono, fontSize: 10, letterSpacing: '0.14em', textTransform: 'uppercase', color: INK3, marginBottom: 16 }}>Business</div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 16 }}>
            <div style={{ gridColumn: 'span 2' }}>
              <label style={labelStyle}>Business Name *</label>
              <input value={f.business_name} onChange={e => set('business_name', e.target.value)} style={inputStyle} placeholder="Almaty Premium Motors LLP" />
            </div>
            <div>
              <label style={labelStyle}>City</label>
              <input value={f.business_city} onChange={e => set('business_city', e.target.value)} style={inputStyle} placeholder="Almaty" />
            </div>
            <div>
              <label style={labelStyle}>Country *</label>
              <select value={f.business_country} onChange={e => set('business_country', e.target.value)} style={{ ...inputStyle, cursor: 'pointer' }}>
                <option value="">Select country</option>
                {COUNTRIES.map(c => <option key={c} value={c}>{c}</option>)}
              </select>
            </div>
            <div style={{ gridColumn: 'span 2' }}>
              <label style={labelStyle}>Business Type</label>
              <select value={f.business_type} onChange={e => set('business_type', e.target.value)} style={{ ...inputStyle, cursor: 'pointer' }}>
                {['dealer', 'garage', 'exporter', 'broker', 'fleet', 'other'].map(t => <option key={t} value={t} style={{ textTransform: 'capitalize' }}>{t.charAt(0).toUpperCase() + t.slice(1)}</option>)}
              </select>
            </div>
          </div>
        </div>

        {/* Contact section */}
        <div style={{ marginBottom: 32 }}>
          <div style={{ fontFamily: mono, fontSize: 10, letterSpacing: '0.14em', textTransform: 'uppercase', color: INK3, marginBottom: 16 }}>Contact</div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
            <div>
              <label style={labelStyle}>Your Name *</label>
              <input value={f.contact_name} onChange={e => set('contact_name', e.target.value)} style={inputStyle} placeholder="Bek Aliyev" />
            </div>
            <div>
              <label style={labelStyle}>Position</label>
              <select value={f.contact_position} onChange={e => set('contact_position', e.target.value)} style={{ ...inputStyle, cursor: 'pointer' }}>
                {['Owner', 'Manager', 'Purchasing', 'Other'].map(p => <option key={p} value={p}>{p}</option>)}
              </select>
            </div>
            <div>
              <label style={labelStyle}>Email *</label>
              <input value={f.contact_email} onChange={e => set('contact_email', e.target.value)} style={inputStyle} placeholder="bek@apmotors.kz" type="email" />
            </div>
            <div>
              <label style={labelStyle}>Phone</label>
              <input value={f.contact_phone} onChange={e => set('contact_phone', e.target.value)} style={inputStyle} placeholder="+7 701 xxx xxxx" />
            </div>
          </div>
        </div>

        {/* License + Documents */}
        <div style={{ marginBottom: 32 }}>
          <div style={{ fontFamily: mono, fontSize: 10, letterSpacing: '0.14em', textTransform: 'uppercase', color: INK3, marginBottom: 16 }}>Trade License</div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 16 }}>
            <div>
              <label style={labelStyle}>License Type</label>
              <select value={f.license_type} onChange={e => set('license_type', e.target.value)} style={{ ...inputStyle, cursor: 'pointer' }}>
                {['Trade License', 'BIN', 'TIN', 'INN', 'CR Number', 'Other'].map(t => <option key={t} value={t}>{t}</option>)}
              </select>
            </div>
            <div>
              <label style={labelStyle}>License Number</label>
              <input value={f.license_number} onChange={e => set('license_number', e.target.value)} style={inputStyle} placeholder="240141023871" />
            </div>
          </div>
          {/* File upload */}
          <label style={labelStyle}>Upload Documents</label>
          <div style={{ padding: 20, border: `2px dashed ${LINE}`, borderRadius: 12, textAlign: 'center', marginBottom: 8, cursor: 'pointer', background: '#FAFAF8' }} onClick={() => fileRef.current?.click()}>
            <div style={{ fontSize: 28, marginBottom: 8 }}>📎</div>
            <div style={{ fontSize: 13, color: INK2, marginBottom: 4 }}>{uploading ? 'Uploading...' : 'Click to choose files'}</div>
            <div style={{ fontSize: 11, color: INK4 }}>PDF, JPG, PNG — max 10MB each</div>
          </div>
          <input ref={fileRef} type="file" accept=".pdf,.jpg,.jpeg,.png" multiple style={{ display: 'none' }} onChange={handleFileUpload} />
          {docs.length > 0 && (
            <div style={{ marginTop: 8 }}>
              {docs.map((d, i) => (
                <div key={d.id} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '8px 12px', background: '#fff', borderRadius: 8, border: `1px solid ${LINE}`, marginBottom: 6 }}>
                  <span>📄</span>
                  <span style={{ flex: 1, fontSize: 13, color: INK }}>{d.name}</span>
                  <span style={{ fontSize: 11, color: GREEN }}>✅</span>
                  <button onClick={() => setDocs(prev => prev.filter((_, j) => j !== i))} style={{ background: 'none', border: 'none', color: INK4, cursor: 'pointer', fontSize: 16 }}>✕</button>
                </div>
              ))}
              <button onClick={() => fileRef.current?.click()} style={{ fontSize: 12, color: BLUE, background: 'none', border: 'none', cursor: 'pointer', padding: 0, marginTop: 4 }}>+ Add more files</button>
            </div>
          )}
        </div>

        {/* About your business */}
        <div style={{ marginBottom: 32 }}>
          <div style={{ fontFamily: mono, fontSize: 10, letterSpacing: '0.14em', textTransform: 'uppercase', color: INK3, marginBottom: 16 }}>About Your Business</div>
          <div style={{ marginBottom: 16 }}>
            <label style={labelStyle}>Monthly Purchase Volume</label>
            <select value={f.monthly_volume} onChange={e => set('monthly_volume', e.target.value)} style={{ ...inputStyle, cursor: 'pointer' }}>
              <option value="less_than_5">Less than 5 units</option>
              <option value="5_to_20">5–20 units</option>
              <option value="20_to_50">20–50 units</option>
              <option value="50_plus">50+ units</option>
            </select>
          </div>
          <div style={{ marginBottom: 16 }}>
            <label style={labelStyle}>Interested In</label>
            <div style={{ display: 'flex', gap: 12 }}>
              {['vehicles', 'engines', 'spare_parts'].map(item => (
                <label key={item} style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 14, color: INK2, cursor: 'pointer' }}>
                  <input type="checkbox" checked={f.interested_in.includes(item)} onChange={() => toggleInterest(item)} style={{ width: 18, height: 18, accentColor: BLUE }} />
                  {item.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())}
                </label>
              ))}
            </div>
          </div>
          <div>
            <label style={labelStyle}>Anything else you'd like us to know</label>
            <textarea value={f.notes} onChange={e => set('notes', e.target.value)} rows={4} style={{ ...inputStyle, height: 'auto', padding: '12px 16px', resize: 'vertical', lineHeight: 1.6 }} placeholder="Tell us about your business, current sourcing, or specific requirements..." />
          </div>
        </div>

        {/* Submit */}
        <button onClick={handleSubmit} disabled={uploading} style={{ width: '100%', height: 56, borderRadius: 14, background: INK, color: '#fff', fontFamily: heading, fontSize: 16, fontWeight: 600, border: 'none', cursor: uploading ? 'wait' : 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, transition: 'background 0.2s' }}>
          Submit Application <span style={{ fontSize: 18 }}>→</span>
        </button>
      </section>
    </div>
  );
}

export default WebsiteTradeApply;
